/**
 * Following ES6 modules work in the context of react-scripts only, that depend on Webpack.
 * If they need to be used in CommonJS environment then refactor to use React.createClass
 */

export {CaseDetails} from '../dols/components'
export {HomePageContent} from '../dols/components'
export {AboutPageContent} from '../dols/components'
